import { FC } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';

import type { LoginForm } from 'src/__generated__/graphqlTypes';
import { DataButton, DataLink } from 'components/Shared/SharedComponents';
import { useButtonBgImageStyles } from 'lib/shared.hook';

import styles from './styles.module.scss';

import { IAuthInteractiveComponent, ISignInButton } from '../config/declarations';

const LoginFormContainer = dynamic(import('components/Header/MiddleBar/Interaction/LoginForm/LoginFormContainer'));

const SignUpButton: FC<any> = ({ signUp }) => {
  const bgImageStyles = useButtonBgImageStyles(signUp!);

  if (!signUp) {
    return null;
  }

  return (
    <DataLink
      href={signUp.src || ''}
      link={signUp}
      style={bgImageStyles || {}}
      className={cn(
        styles.authSignUp,
        { [styles[signUp.slug]]: signUp.slug },
      )}
    >
      {signUp.title}
    </DataLink>
  );
};

/* Nested Component */
const SignInButton: FC<ISignInButton> = ({ signIn, setShownFormState, isShownForm }) => {
  if (!signIn) {
    return null;
  }

  if (process.env.NEXT_PUBLIC_KEEP_SIGN_IN_FLYOUT === 'true') {
    return (
      <DataButton
        aria-label={signIn.title || ''}
        className={styles.authSignInButton}
        data-ajax="false"
        onClick={() => setShownFormState(!isShownForm)}
        onKeyPress={() => setShownFormState(!isShownForm)}
      >
        {signIn.title}
      </DataButton>
    );
  }

  return (
    <DataLink
      link={signIn}
      className={styles.authSignInButton}
    >
      {signIn.title}
    </DataLink>
  );
};

/* Main Component */
const NCView: FC<IAuthInteractiveComponent> = ({
  signInRef,
  auth,
  isShownForm,
  setShownFormState,
}) => {
  if (!auth) {
    return null;
  }

  const { signUp, collapsed, signIn } = auth;

  return (
    <>
      {signUp && <SignUpButton signUp={signUp} />}
      <div ref={signInRef} className={styles.authSignIn}>
        <SignInButton
          isShownForm={isShownForm}
          setShownFormState={setShownFormState}
          signIn={signIn}
        />
        { process.env.NEXT_PUBLIC_KEEP_SIGN_IN_FLYOUT === 'true' && (
          <LoginFormContainer
            isShown={isShownForm}
            loginForm={collapsed as LoginForm}
            setShownFormState={setShownFormState}
          />
        )}
      </div>
    </>
  );
};

export default NCView;
